export default __webpack_public_path__ + "fonts/fc9003575a03798e8b115d070db73ab6.woff";